import React from "react";
import { UsedIcon, RejectedIcon } from "../../../../Components/Icons";
import { UsedDismissedIconContainer } from "./StatusIcon.styled";

const StatusIcon = ({ isUsed, isDismissed, isVertical = false }) => {
  if (!isUsed && !isDismissed) return null;

  return (
    <UsedDismissedIconContainer isVertical={isVertical}>
      {isUsed && <UsedIcon size={30} />}
      {isDismissed && <RejectedIcon size={30} />}
    </UsedDismissedIconContainer>
  );
};

export default StatusIcon;
